var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTtf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m489.715 167.004v284.952c0 26.534-21.51 48.044-48.044 48.044h-296.28c-26.534 0-48.044-21.51-48.044-48.044v-391.912c0-26.534 21.51-48.044 48.044-48.044h198.441z",
    fill: "#57626f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.714 167.004h-113.853c-17.689 0-32.029-14.34-32.029-32.029v-122.974z",
    fill: "#0e1e31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.888 427.607h-371.403c-5.081 0-9.2-4.119-9.2-9.2v-168.324c0-5.081 4.119-9.2 9.2-9.2h371.403c5.081 0 9.2 4.119 9.2 9.2v168.324c0 5.081-4.119 9.2-9.2 9.2z",
    fill: "#0e1e31"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m146.464 382.919c-1.783 0-3.441-.375-4.911-1.189-1.47-.813-2.221-1.971-2.221-3.503v-80.574h-20.832c-1.439 0-2.565-.688-3.378-2.002-.813-1.376-1.22-2.878-1.22-4.598 0-1.595.375-3.097 1.095-4.442.719-1.345 1.877-2.033 3.503-2.033h55.801c1.72 0 2.94.688 3.628 2.033.719 1.345 1.095 2.784 1.095 4.316 0 1.783-.375 3.347-1.157 4.723-.751 1.314-1.939 2.002-3.566 2.002h-20.706v80.574c0 1.533-.751 2.69-2.221 3.503-1.469.815-3.127 1.19-4.91 1.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.526 382.919c-1.783 0-3.441-.375-4.911-1.189-1.47-.813-2.221-1.971-2.221-3.503v-80.574h-20.832c-1.439 0-2.565-.688-3.378-2.002-.813-1.376-1.22-2.878-1.22-4.598 0-1.595.375-3.097 1.095-4.442s1.877-2.033 3.503-2.033h55.801c1.72 0 2.94.688 3.628 2.033.719 1.345 1.095 2.784 1.095 4.316 0 1.783-.375 3.347-1.157 4.723-.751 1.314-1.939 2.002-3.566 2.002h-20.706v80.574c0 1.533-.751 2.69-2.221 3.503-1.469.815-3.127 1.19-4.91 1.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.572 382.919c-1.814 0-3.441-.375-4.911-1.126s-2.221-1.939-2.221-3.566v-88.925c0-1.533.657-2.69 2.002-3.472 1.345-.813 2.784-1.251 4.316-1.251h47.231c1.595 0 2.753.688 3.472 2.033s1.095 2.721 1.095 4.16c0 1.72-.375 3.222-1.157 4.504-.751 1.314-1.908 1.971-3.409 1.971h-39.286v30.809h20.832c1.533 0 2.69.563 3.441 1.752.751 1.157 1.157 2.502 1.157 4.004 0 1.282-.375 2.502-1.095 3.722-.719 1.22-1.877 1.814-3.503 1.814h-20.832v38.879c0 1.626-.751 2.815-2.221 3.566-1.502.751-3.128 1.126-4.911 1.126z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTtf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ttf.2d6b4df6b936380b2c72eccd91d124c1.svg";